import { useState, useEffect, useCallback } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../services/firebase';
import { useAuthContext } from '../context/AuthContext';

/**
 * Fetches the current user's active pick (if any).
 * Uses one-time fetch to avoid Firestore SDK listener bugs.
 */
export function useActivePick() {
  const { user } = useAuthContext();
  const [activePick, setActivePick] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchActivePick = useCallback(async () => {
    if (!user) {
      setActivePick(null);
      setLoading(false);
      return;
    }

    try {
      const q = query(
        collection(db, 'picks'),
        where('uid', '==', user.uid),
        where('isActive', '==', true)
      );

      const snapshot = await getDocs(q);
      if (snapshot.empty) {
        setActivePick(null);
      } else {
        const doc = snapshot.docs[0];
        setActivePick({ id: doc.id, ...doc.data() });
      }
    } catch (err) {
      console.error('Error fetching active pick:', err);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchActivePick();
  }, [fetchActivePick]);

  return { activePick, loading, refetch: fetchActivePick };
}
